// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"66a153ef","363":"bf31f8bb","478":"abc14b23","569":"a94020ec"}[chunkId] + ".chunk.js";
};